import { ITabTemplate } from './i-tab-template';
import { ITab } from './i-tab';

export class TabSession {
  templates: ITabTemplate[] = [];
  tabs: ITab[] = [];
}
